import React, { forwardRef } from 'react';
import { Carousel } from '@design-system/carousel';

import HeroSlide from './HeroSlide';

const SLIDE_KEY = /^s(\d+)\.(.+)$/;

const parseSlides = (props) => {
  const buckets = new Map();
  let hasPrefixedKeys = false;

  Object.entries(props).forEach(([key, value]) => {
    const match = SLIDE_KEY.exec(key);
    if (!match) return;

    hasPrefixedKeys = true;
    const index = Number(match[1]);
    const field = match[2];

    if (!buckets.has(index)) buckets.set(index, {});
    buckets.get(index)[field] = value;
  });

  if (!hasPrefixedKeys) return [props];

  return [...buckets.entries()].sort(([a], [b]) => a - b).map(([, slide]) => slide);
};

const HeroCarousel = forwardRef((props, ref) => {
  const slides = parseSlides(props);

  if (slides.length === 0) return null;
  if (slides.length === 1) return <HeroSlide ref={ref} {...slides[0]} />;

  return (
    <Carousel
      ref={ref}
      className="hkx-hero-carousel"
      variant="single"
      gap={0}
      centerInsufficientSlides={false}
      buttonPrev={{ 'aria-label': 'Anterior' }}
      buttonNext={{ 'aria-label': 'Siguiente' }}
      ariaLivePlaceholder={(activeIndex, totalCount) => `${activeIndex} de ${totalCount}`}
      items={slides.map((slide) => ({ children: <HeroSlide {...slide} /> }))}
    />
  );
});

HeroCarousel.displayName = 'HeroCarousel';

export default HeroCarousel;
